import React from 'react';
import { Search, Star, Award, Settings, Trophy, Wrench, Car, Users } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';

const iconMap = {
  Search: Search,
  Star: Star,
  Award: Award,
  Settings: Settings,
  Trophy: Trophy,
  Wrench: Wrench,
  Car: Car,
  Users: Users
};

const WhyChooseSection = () => {
  const { isDark } = useTheme();

  return (
    <section className={`py-20 ${isDark ? 'bg-neutral-900' : 'bg-white'}`}>
      <div className="max-w-6xl mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-lime-500">
            Why Choose JPR Customs?
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            
            return (
              <div
                key={item.id}
                className={`p-6 rounded-xl transition-all duration-300 hover:scale-[1.02] hover:shadow-lg ${
                  isDark 
                    ? 'bg-neutral-800 hover:bg-neutral-750' 
                    : 'bg-neutral-50 hover:bg-white shadow-sm'
                }`}
              >
                <div className="w-14 h-14 bg-lime-500 rounded-full flex items-center justify-center mb-4">
                  <IconComponent className="w-7 h-7 text-black" />
                </div>
                <h3 className="text-lg font-bold text-lime-500 mb-2">
                  {item.title}
                </h3>
                <p className={isDark ? 'text-neutral-400' : 'text-neutral-600'}>
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
